import { Component, Input } from '@angular/core';

@Component({
    selector: 'apc-budget-creation-modal',
    templateUrl: './budget-creation-modal.component.html',
    styleUrls: ['./budget-creation-modal.component.scss', '../project-management/project-management.component.scss'],
    standalone: false
})
export class BudgetCreationModalComponent {
  @Input() modalRef: any;

  constructor() { }

  close(res: boolean) {
    this.modalRef.dismiss(res);
  }


}
